(() => {
  function initMadesaPreviewVitrine(section) {
    const colorBtns = section.querySelectorAll('.madesa-preview__color-btn');
    const lineBtns = section.querySelectorAll('.madesa-preview__line-btn');
    const items = section.querySelectorAll('.js-image-item');
    const emptyState = section.querySelector('.js-empty-state');
    const grid = section.querySelector('.js-image-grid');
    const thumb = section.querySelector('.js-progress-thumb');
    const prevBtn = section.querySelector('.js-nav-prev');
    const nextBtn = section.querySelector('.js-nav-next');

    let activeLineBtn = section.querySelector('.madesa-preview__line-btn.active');
    let activeColorBtn = section.querySelector('.madesa-preview__color-btn.active');

    let activeLine = activeLineBtn ? activeLineBtn.dataset.linha : '';
    let activeColor = activeColorBtn ? activeColorBtn.dataset.cor : 'all';

    function updateProgressBar() {
      const scrollWidth = grid.scrollWidth;
      const clientWidth = grid.clientWidth;

      if (grid.scrollLeft <= 0) {
        if (prevBtn) {
          prevBtn.classList.add('disabled');
          prevBtn.setAttribute('disabled', 'true');
        }
      } else if (prevBtn) {
        prevBtn.classList.remove('disabled');
        prevBtn.removeAttribute('disabled');
      }

      if (Math.ceil(grid.scrollLeft + clientWidth) >= scrollWidth - 2) {
        if (nextBtn) {
          nextBtn.classList.add('disabled');
          nextBtn.setAttribute('disabled', 'true');
        }
      } else if (nextBtn) {
        nextBtn.classList.remove('disabled');
        nextBtn.removeAttribute('disabled');
      }

      if (scrollWidth <= clientWidth) {
        thumb.style.width = '100%';
        thumb.style.transform = 'translateX(0px)';
        return;
      }

      const scrollRatio = clientWidth / scrollWidth;
      thumb.style.width = `${scrollRatio * 100}%`;

      const maxScrollLeft = scrollWidth - clientWidth;
      const maxThumbMove = clientWidth - (clientWidth * scrollRatio);
      const currentScrollRatio = grid.scrollLeft / maxScrollLeft;
      const thumbPosition = maxThumbMove * currentScrollRatio;

      thumb.style.transform = `translateX(${thumbPosition}px)`;
    }

    function filterGallery() {
      let visibleCount = 0;
      const availableColors = new Set();

      items.forEach((item) => {
        if (activeLine === '' || item.dataset.linha === activeLine) {
          availableColors.add(item.dataset.cor);
        }
      });

      colorBtns.forEach((btn) => {
        const btnColor = btn.dataset.cor;
        if (btnColor === 'all' || availableColors.has(btnColor)) {
          btn.style.display = '';
        } else {
          btn.style.display = 'none';
          if (btn.classList.contains('active')) {
            btn.classList.remove('active');
            activeColor = 'all';
            const allBtn = section.querySelector('.madesa-preview__color-btn--all');
            if (allBtn) allBtn.classList.add('active');
          }
        }
      });

      items.forEach((item) => {
        const lineMatches = activeLine === '' || item.dataset.linha === activeLine;
        const colorMatches = activeColor === 'all' || item.dataset.cor === activeColor;

        if (lineMatches && colorMatches) {
          item.style.display = 'block';
          visibleCount += 1;
        } else {
          item.style.display = 'none';
        }
      });

      emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
      grid.scrollLeft = 0;
      updateProgressBar();
    }

    colorBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        colorBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        activeColor = btn.dataset.cor;
        filterGallery();
      });
    });

    lineBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        lineBtns.forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        activeLine = btn.dataset.linha;
        filterGallery();
      });
    });

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        const visibleItems = Array.from(items).filter(i => i.style.display === 'block');
        const itemWidth = visibleItems[0] ? visibleItems[0].offsetWidth + 16 : 300;
        grid.scrollBy({ left: -itemWidth, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        const visibleItems = Array.from(items).filter(i => i.style.display === 'block');
        const itemWidth = visibleItems[0] ? visibleItems[0].offsetWidth + 16 : 300;
        grid.scrollBy({ left: itemWidth, behavior: 'smooth' });
      });
    }

    let isDragging = false;
    let startX;
    let startScrollLeft;

    const startDrag = (pageX) => {
      isDragging = true;
      startX = pageX;
      startScrollLeft = grid.scrollLeft;
      thumb.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
    };

    const drag = (pageX) => {
      if (!isDragging) return;
      const walkX = pageX - startX;
      const maxScrollLeft = grid.scrollWidth - grid.clientWidth;
      const maxThumbMove = grid.clientWidth - thumb.offsetWidth;
      const ratio = maxScrollLeft / maxThumbMove;
      
      grid.scrollLeft = startScrollLeft + (walkX * ratio);
    };

    const stopDrag = () => {
      isDragging = false;
      thumb.style.cursor = 'grab';
      document.body.style.userSelect = '';
    };

    thumb.addEventListener('mousedown', (e) => startDrag(e.pageX));
    window.addEventListener('mousemove', (e) => { if (isDragging) drag(e.pageX); });
    window.addEventListener('mouseup', stopDrag);

    thumb.addEventListener('touchstart', (e) => startDrag(e.touches[0].pageX), {passive: true});
    window.addEventListener('touchmove', (e) => { if (isDragging) drag(e.touches[0].pageX); }, {passive: true});
    window.addEventListener('touchend', stopDrag);

    grid.addEventListener('scroll', updateProgressBar);
    window.addEventListener('resize', updateProgressBar);

    filterGallery();
    setTimeout(updateProgressBar, 100);
  }

  function init() {
    document.querySelectorAll('[data-madesa-preview-vitrine]').forEach(initMadesaPreviewVitrine);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();